module.exports = __webpack_public_path__ + "img/6c9c1e7.jpg";